module.exports = __webpack_public_path__ + "static/media/about.f2de3600.jpg";